export enum FanViewLanguage {
  ko = "ko",
  en = "en",
  ja = "ja",
  es = "es",
  "zh-cn" = "zh-cn",
  "zh-tw" = "zh-tw",
}
